<template lang="pug">
div
    //- list of counted stock
    .box
        .box-header
            h3 Stocks to Request

        //- form to validate stock quantity
        form
            v-client-table(
                :data="stocks",
                :columns="columns",
                :options="options",
                ref="datatable",
            )
                template(slot="requested_quantity" slot-scope="props")
                    div(v-if="canUpdate && isOpen")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('request quantity', `requested_quantity_${props.row.stock_id}`) }",
                            type="text",
                            name="request quantity",
                            autocomplete="off",
                            placeholder="Enter Qty",
                            v-validate="`required|decimal:2|min_value:0`",
                            :data-vv-scope="`requested_quantity_${props.row.stock_id}`",
                            :id="`requested_quantity_${props.row.stock_id}`",
                            :key="`requested_quantity_${props.row.stock_id}`",
                            @input="updateRequestStock({stock_id: props.row.stock_id, key: 'requested_quantity', value: $event.target.value})",
                            :value="props.row.requested_quantity"
                        )
                        span.text-danger(v-if="errors.has('request quantity', `requested_quantity_${props.row.stock_id}`)")
                            | {{ errors.first('request quantity', `requested_quantity_${props.row.stock_id}`) }}

                    span(v-else) {{ props.row.requested_quantity  }}

                template(slot="approved_quantity" slot-scope="props")
                    div(v-if="canApprove && isWaitingApproval")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('approve quantity', `approved_quantity_${props.row.stock_id}`) }",
                            type="text",
                            name="approve quantity",
                            autocomplete="off",
                            placeholder="Enter Qty",
                            v-validate="`required|decimal:2|min_value:0|max_value:${props.row.source_outlet_quantity}`",
                            :data-vv-scope="`approved_quantity_${props.row.stock_id}`",
                            :id="`approved_quantity_${props.row.stock_id}`",
                            :key="`approved_quantity_${props.row.stock_id}`",
                            @input="updateRequestStock({stock_id: props.row.stock_id, key: 'approved_quantity', value: $event.target.value})",
                            :value="props.row.approved_quantity"
                        )
                        span.text-danger(v-if="errors.has('approve quantity', `approved_quantity_${props.row.stock_id}`)")
                            | {{ errors.first('approve quantity', `approved_quantity_${props.row.stock_id}`) }}

                    span(v-else) {{ props.row.approved_quantity  }}

                template(slot="received_quantity" slot-scope="props")
                    div(v-if="canUpdate && isApproved")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('receive quantity', `received_quantity_${props.row.stock_id}`) }",
                            type="text",
                            name="receive quantity",
                            autocomplete="off",
                            placeholder="Enter Qty",
                            v-validate="`required|decimal:2|min_value:0`",
                            :data-vv-scope="`received_quantity_${props.row.stock_id}`",
                            :id="`received_quantity_${props.row.stock_id}`",
                            :key="`received_quantity_${props.row.stock_id}`",
                            @input="updateRequestStock({stock_id: props.row.stock_id, key: 'received_quantity', value: $event.target.value})",
                            :value="receivedQtyValue(props.row)"
                        )
                        span.text-danger(v-if="errors.has('receive quantity', `received_quantity_${props.row.stock_id}`)")
                            | {{ errors.first('receive quantity', `received_quantity_${props.row.stock_id}`) }}

                    span(v-else) {{ props.row.received_quantity  }}

                template(slot="price" slot-scope="props")
                    div(v-if="canApprove && isWaitingApproval")
                        input.w-sm.form-control(
                            :class="{ 'has-error': errors.has('price', `price_${props.row.stock_id}`) }",
                            type="text",
                            name="price",
                            autocomplete="off",
                            placeholder="Enter Price",
                            v-validate="'required|decimal:2|min_value:0'",
                            :data-vv-scope="`price_${props.row.stock_id}`",
                            :id="`price_${props.row.stock_id}`",
                            :key="`price_${props.row.stock_id}`",
                            @input="updateRequestStock({stock_id: props.row.stock_id, key: 'price', value: $event.target.value})",
                            :value="props.row.price"
                        )
                        span.text-danger(v-if="errors.has('price', `price_${props.row.stock_id}`)")
                            | {{ errors.first('price', `price_${props.row.stock_id}`) }}

                    span(v-else) {{ formattedNumber(props.row.price)  }}

                template(slot="total" slot-scope="props")
                    span {{ total(props.row) }}

                template(slot="action", slot-scope="props")
                    button.md-btn.md-flat.m-b-sm.btn-xs.text-muted(
                        v-if="canUpdate && isOpen",
                        type="button",
                        @click="removeRequestStock(props.row.stock_id)"
                    )
                        i.material-icons delete
                </button>

                template(slot="appendBody")
                    tr(v-show="isWaitingApproval || isApproved || hasFinalized")
                        td.text-right._500(:colspan="colspan") Total
                        td.text-center._500 {{ formattedNumber(totalPrice) }}
                        td(v-if="isOpen")
                
                template(slot="afterTable")
                    .row.p-a(v-if="canUpdate && isOpen")
                        .col-md-6.col-md-offset-6
                            .form-group
                                label.m-b-0._500 Select Stock to Request
                                stock-inventory-selector(
                                    placeholder="Select stock",
                                    :outlet-id="stockRequest.request_from_outlet_id",
                                    @select="onSelectStock"
                                )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import stockRequestMixin from './stock-request-mixin';

export default {
    inject: ['$validator'],

    mixins: [stockRequestMixin],

    data() {
        return {
            checkedAll: false,
            colspan: 10,
            columns: [
                'name',
                'sku',
                'barcode',
                'source_outlet_quantity',
                'requested_quantity',
                'approved_quantity',
                'received_quantity',
                'price',
                'total',
                'action',
            ],
            options: {
                filterable: false,
                sortable: [],
                perPage: 1000,
                perPageValues: [1000],
                headings: {
                    price: 'Price',
                    source_outlet_quantity: 'Source Outlet Qty',
                    requested_quantity: 'Request Qty',
                    approved_quantity: 'Approve Qty',
                    received_quantity: 'Receive Qty',
                    action: '',
                },
                columnsClasses: {
                    action: 'w-xs',
                    source_outlet_quantity: 'w-sm text-center',
                    requested_quantity: 'w-sm text-center',
                    approved_quantity: 'w-sm text-center',
                    received_quantity: 'w-sm text-center',
                    price: 'w-sm text-center',
                    total: 'text-nowrap w-sm text-center',
                },
                skin: 'table m-b-0 b-b',
                uniqueKey: 'stock_id',
            },
        };
    },

    computed: {
        ...mapGetters('stockRequest', [
            'stocks',
            'findStockIndex',
            'totalPrice',
        ]),
    },

    watch: {
        'stockRequest.status'(status) {
            this.$refs.datatable.userControlsColumns = true;
            let cols = ['name', 'sku', 'barcode'];

            if (status == this.statuses.OPENED) {
                cols = cols.concat([
                    'source_outlet_quantity',
                    'requested_quantity',
                    'action',
                ]);
            } else if (status == this.statuses.DECLINED) {
                cols = cols.concat(['requested_quantity', 'price', 'total']);
            } else if (status == this.statuses.REQUESTED) {
                cols = cols.concat([
                    'source_outlet_quantity',
                    'requested_quantity',
                    'approved_quantity',
                    'price',
                    'total',
                ]);
            } else if (
                status == this.statuses.RECEIVED ||
                status == this.statuses.APPROVED
            ) {
                cols = cols.concat([
                    'requested_quantity',
                    'approved_quantity',
                    'received_quantity',
                    'price',
                    'total',
                ]);
            }

            this.colspan = cols.length - (this.isOpen ? 2 : 1);
            this.$refs.datatable.userColumnsDisplay = cols;
        },
    },

    methods: {
        ...mapActions('stockRequest', [
            'removeRequestStock',
            'addRequestStock',
            'updateRequestStock',
        ]),

        total(stock) {
            const price = parseFloat(stock.price);
            const quantity = parseFloat(stock.approved_quantity);

            if (_.isNaN(price) || _.isNaN(quantity)) return 0;

            return this.formattedNumber(price * quantity);
        },

        onSelectStock(stockInventory) {
            if (this.findStockIndex(stockInventory.stock_id) >= 0) {
                $(`#requested_quantity_${stockInventory.stock_id}`).focus();
            } else {
                this.addRequestStock(stockInventory);
            }
        },

        receivedQtyValue(stock) {
            if (_.isNull(stock.received_quantity)) {
                this.updateRequestStock({
                    stock_id: stock.stock_id,
                    key: 'received_quantity',
                    value: stock.approved_quantity,
                });
            }

            return stock.received_quantity;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_request/stock-request-edit-stocks.vue